import executeQuery from "#lib/db"

export const getIngredients = async () => {
	const list = await executeQuery({
		query: "select * from ingredients",
	})

	return list
}
